var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, e) {
        return e.a = n, e.f = r, e;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(e) {
                return n(r, e);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(e) {
                return function(t) {
                    return n(r, e, t);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return n(r, e, t, a);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(i) {
                            return n(r, e, t, a, i);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(i) {
                            return function(o) {
                                return n(r, e, t, a, i, o);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(i) {
                            return function(o) {
                                return function(u) {
                                    return n(r, e, t, a, i, o, u);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, e) {
        return 2 === n.a ? n.f(r, e) : n(r)(e);
    }
    function A3(n, r, e, t) {
        return 3 === n.a ? n.f(r, e, t) : n(r)(e)(t);
    }
    function A4(n, r, e, t, a) {
        return 4 === n.a ? n.f(r, e, t, a) : n(r)(e)(t)(a);
    }
    function A5(n, r, e, t, a, i) {
        return 5 === n.a ? n.f(r, e, t, a, i) : n(r)(e)(t)(a)(i);
    }
    function A6(n, r, e, t, a, i, o) {
        return 6 === n.a ? n.f(r, e, t, a, i, o) : n(r)(e)(t)(a)(i)(o);
    }
    function A7(n, r, e, t, a, i, o, u) {
        return 7 === n.a ? n.f(r, e, t, a, i, o, u) : n(r)(e)(t)(a)(i)(o)(u);
    }
    function e(n, r) {
        for(var e, a = [], i = t(n, r, 0, a); i && (e = a.pop()); i = t(e.a, e.b, 0, a));
        return i;
    }
    function t(n, r, e, a) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && k(5), !1;
        if (e > 100) return a.push(o(n, r)), !0;
        for(var i in 0 > n.$ && (n = yr(n), r = yr(r)), n)if (!t(n[i], r[i], e + 1, a)) return !1;
        return !0;
    }
    function a(n, r, e) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (e = a(n.a, r.a)) || (e = a(n.b, r.b)) ? e : a(n.c, r.c);
        for(; n.b && r.b && !(e = a(n.a, r.a)); n = n.b, r = r.b);
        return e || (n.b ? 1 : r.b ? -1 : 0);
    }
    var i = F2(function(n, r) {
        var e = a(n, r);
        return 0 > e ? pr : e ? hr : br;
    });
    function o(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function u(n, r) {
        var e = {};
        for(var t in n)e[t] = n[t];
        for(var t in r)e[t] = r[t];
        return e;
    }
    function s(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var e = f(n.a, r);
        n = n.b;
        for(var t = e; n.b; n = n.b)t = t.b = f(n.a, r);
        return e;
    }
    var c = {
        $: 0
    };
    function f(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var l = F2(f);
    function d(n) {
        for(var r = c, e = n.length; e--;)r = f(n[e], r);
        return r;
    }
    var v = F3(function(n, r, e) {
        for(var t = []; r.b && e.b; r = r.b, e = e.b)t.push(A2(n, r.a, e.a));
        return d(t);
    }), b = F3(function(n, r, e) {
        for(var t = Array(n), a = 0; n > a; a++)t[a] = e(r + a);
        return t;
    }), h = F2(function(n, r) {
        for(var e = Array(n), t = 0; n > t && r.b; t++)e[t] = r.a, r = r.b;
        return e.length = t, o(e, r);
    }), p = F2(function(n, r) {
        return r[n];
    }), m = F3(function(n, r, e) {
        for(var t = e.length, a = Array(t), i = 0; t > i; i++)a[i] = e[i];
        return a[n] = r, a;
    }), g = F3(function(n, r, e) {
        for(var t = e.length, a = 0; t > a; a++)r = A2(n, e[a], r);
        return r;
    }), y = F3(function(n, r, e) {
        for(var t = e.length - 1; t >= 0; t--)r = A2(n, e[t], r);
        return r;
    }), $ = F2(function(n, r) {
        for(var e = r.length, t = Array(e), a = 0; e > a; a++)t[a] = n(r[a]);
        return t;
    }), w = F3(function(n, r, e) {
        for(var t = e.length, a = Array(t), i = 0; t > i; i++)a[i] = A2(n, r + i, e[i]);
        return a;
    });
    function k(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var A = Math.ceil, I = Math.floor, j = Math.log, O = F2(function(n, r) {
        return r.split(n);
    }), T = F2(function(n, r) {
        return r.join(n);
    }), S = F3(function(n, r, e) {
        return e.slice(n, r);
    }), x = F2(function(n, r) {
        for(var e = r.length; e--;){
            var t = r[e], a = r.charCodeAt(e);
            if (56320 > a || a > 57343 || (t = r[--e] + t), !n(t)) return !1;
        }
        return !0;
    }), q = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), C = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), _ = F2(function(n, r) {
        var e = n.length;
        if (1 > e) return c;
        for(var t = 0, a = []; (t = r.indexOf(n, t)) > -1;)a.push(t), t += e;
        return d(a);
    });
    function N(n) {
        return {
            $: 2,
            b: n
        };
    }
    N(function(n) {
        return "number" != typeof n ? U("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Tr(n) : !isFinite(n) || n % 1 ? U("an INT", n) : Tr(n);
    }), N(function(n) {
        return "boolean" == typeof n ? Tr(n) : U("a BOOL", n);
    }), N(function(n) {
        return "number" == typeof n ? Tr(n) : U("a FLOAT", n);
    }), N(function(n) {
        return Tr(n);
    });
    var E = N(function(n) {
        return "string" == typeof n ? Tr(n) : n instanceof String ? Tr(n + "") : U("a STRING", n);
    }), H = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function P(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var L = F2(function(n, r) {
        return P(n, [
            r
        ]);
    }), F = F3(function(n, r, e) {
        return P(n, [
            r,
            e
        ]);
    }), Y = F4(function(n, r, e, t) {
        return P(n, [
            r,
            e,
            t
        ]);
    }), M = F6(function(n, r, e, t, a, i) {
        return P(n, [
            r,
            e,
            t,
            a,
            i
        ]);
    }), R = F2(function(n, r) {
        try {
            return W(n, JSON.parse(r));
        } catch (n) {
            return Ar(A2(Ir, "This is not valid JSON! " + n.message, r));
        }
    }), V = F2(function(n, r) {
        return W(n, r);
    });
    function W(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Tr(n.c) : U("null", r);
            case 3:
                return D(r) ? B(n.b, r, d) : U("a LIST", r);
            case 4:
                return D(r) ? B(n.b, r, G) : U("an ARRAY", r);
            case 6:
                var e = n.d;
                if ("object" != typeof r || null === r || !(e in r)) return U("an OBJECT with a field named `" + e + "`", r);
                var t = W(n.b, r[e]);
                return me(t) ? t : Ar(A2(jr, e, t.a));
            case 7:
                var a = n.e;
                return D(r) ? r.length > a ? (t = W(n.b, r[a]), me(t) ? t : Ar(A2(Or, a, t.a))) : U("a LONGER array. Need index " + a + " but only see " + r.length + " entries", r) : U("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || D(r)) return U("an OBJECT", r);
                var i = c;
                for(var u in r)if (r.hasOwnProperty(u)) {
                    if (t = W(n.b, r[u]), !me(t)) return Ar(A2(jr, u, t.a));
                    i = f(o(u, t.a), i);
                }
                return Tr(Ur(i));
            case 9:
                for(var s = n.f, l = n.g, v = 0; l.length > v; v++){
                    if (t = W(l[v], r), !me(t)) return t;
                    s = s(t.a);
                }
                return Tr(s);
            case 10:
                return t = W(n.b, r), me(t) ? W(n.h(t.a), r) : t;
            case 11:
                for(var b = c, h = n.g; h.b; h = h.b){
                    if (t = W(h.a, r), me(t)) return t;
                    b = f(t.a, b);
                }
                return Ar(Sr(Ur(b)));
            case 1:
                return Ar(A2(Ir, n.a, r));
            case 0:
                return Tr(n.a);
        }
    }
    function B(n, r, e) {
        for(var t = r.length, a = Array(t), i = 0; t > i; i++){
            var o = W(n, r[i]);
            if (!me(o)) return Ar(A2(Or, i, o.a));
            a[i] = o.a;
        }
        return Tr(e(a));
    }
    function D(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function G(n) {
        return A2(pe, n.length, function(r) {
            return n[r];
        });
    }
    function U(n, r) {
        return Ar(A2(Ir, "Expecting " + n, r));
    }
    function J(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return J(n.b, r.b);
            case 6:
                return n.d === r.d && J(n.b, r.b);
            case 7:
                return n.e === r.e && J(n.b, r.b);
            case 9:
                return n.f === r.f && z(n.g, r.g);
            case 10:
                return n.h === r.h && J(n.b, r.b);
            case 11:
                return z(n.g, r.g);
        }
    }
    function z(n, r) {
        var e = n.length;
        if (e !== r.length) return !1;
        for(var t = 0; e > t; t++)if (!J(n[t], r[t])) return !1;
        return !0;
    }
    var K = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function X(n) {
        return n;
    }
    var Z = F3(function(n, r, e) {
        return e[n] = r, e;
    });
    function Q(n) {
        return {
            $: 0,
            a: n
        };
    }
    function nn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var rn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), en = 0;
    function tn(n) {
        var r = {
            $: 0,
            e: en++,
            f: n,
            g: null,
            h: []
        };
        return fn(r), r;
    }
    function an(n) {
        return nn(function(r) {
            r(Q(tn(n)));
        });
    }
    function on(n, r) {
        n.h.push(r), fn(n);
    }
    var un = F2(function(n, r) {
        return nn(function(e) {
            on(n, r), e(Q(0));
        });
    }), sn = !1, cn = [];
    function fn(n) {
        if (cn.push(n), !sn) {
            for(sn = !0; n = cn.shift();)ln(n);
            sn = !1;
        }
    }
    function ln(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, fn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var dn = {};
    function vn(n, r, e, t, a) {
        return {
            b: n,
            c: r,
            d: e,
            e: t,
            f: a
        };
    }
    function bn(n, r) {
        var e = {
            g: r,
            h: void 0
        }, t = n.c, a = n.d, i = n.e, o = n.f;
        function u(n) {
            return A2(rn, u, {
                $: 5,
                b: function(r) {
                    var u = r.a;
                    return 0 === r.$ ? A3(a, e, u, n) : i && o ? A4(t, e, u.i, u.j, n) : A3(t, e, i ? u.i : u.j, n);
                }
            });
        }
        return e.h = tn(A2(rn, u, n.b));
    }
    var hn = F2(function(n, r) {
        return nn(function(e) {
            n.g(r), e(Q(0));
        });
    }), pn = F2(function(n, r) {
        return A2(un, n.h, {
            $: 0,
            a: r
        });
    });
    function mn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function gn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var yn, $n = [], wn = !1;
    function kn(n, r, e) {
        if ($n.push({
            p: n,
            q: r,
            r: e
        }), !wn) {
            wn = !0;
            for(var t; t = $n.shift();)An(t.p, t.q, t.r);
            wn = !1;
        }
    }
    function An(n, r, e) {
        var t = {};
        for(var a in In(!0, r, t, null), In(!1, e, t, null), n)on(n[a], {
            $: "fx",
            a: t[a] || {
                i: c,
                j: c
            }
        });
    }
    function In(n, r, e, t) {
        switch(r.$){
            case 1:
                var a = r.k, i = function(n, r, e, t) {
                    function a(n) {
                        for(var r = e; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? dn[r].e : dn[r].f, a, t);
                }(n, a, t, r.l);
                return void (e[a] = function(n, r, e) {
                    return e = e || {
                        i: c,
                        j: c
                    }, n ? e.i = f(r, e.i) : e.j = f(r, e.j), e;
                }(n, i, e[a]));
            case 2:
                for(var o = r.m; o.b; o = o.b)In(n, o.a, e, t);
                return;
            case 3:
                return void In(n, r.o, e, {
                    s: r.n,
                    t: t
                });
        }
    }
    var jn = "undefined" != typeof document ? document : {};
    function On(n, r) {
        n.appendChild(r);
    }
    function Tn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Sn = F2(function(n, r) {
        return F2(function(e, t) {
            for(var a = [], i = 0; t.b; t = t.b){
                var o = t.a;
                i += o.b || 0, a.push(o);
            }
            return i += a.length, {
                $: 1,
                c: r,
                d: Nn(e),
                e: a,
                f: n,
                b: i
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(e, t) {
            for(var a = [], i = 0; t.b; t = t.b){
                var o = t.a;
                i += o.b.b || 0, a.push(o);
            }
            return i += a.length, {
                $: 2,
                c: r,
                d: Nn(e),
                e: a,
                f: n,
                b: i
            };
        });
    })(void 0);
    var xn, qn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), Cn = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), _n = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function Nn(n) {
        for(var r = {}; n.b; n = n.b){
            var e = n.a, t = e.$, a = e.n, i = e.o;
            if ("a2" !== t) {
                var o = r[t] || (r[t] = {});
                "a3" === t && "class" === a ? En(o, a, i) : o[a] = i;
            } else "className" === a ? En(r, a, i) : r[a] = i;
        }
        return r;
    }
    function En(n, r, e) {
        var t = n[r];
        n[r] = t ? t + " " + e : e;
    }
    function Hn(n, r) {
        var e = n.$;
        if (5 === e) return Hn(n.k || (n.k = n.m()), r);
        if (0 === e) return jn.createTextNode(n.a);
        if (4 === e) {
            for(var t = n.k, a = n.j; 4 === t.$;)"object" != typeof a ? a = [
                a,
                t.j
            ] : a.push(t.j), t = t.k;
            var i = {
                j: a,
                p: r
            };
            return (o = Hn(t, i)).elm_event_node_ref = i, o;
        }
        if (3 === e) return Pn(o = n.h(n.g), r, n.d), o;
        var o = n.f ? jn.createElementNS(n.f, n.c) : jn.createElement(n.c);
        yn && "a" == n.c && o.addEventListener("click", yn(o)), Pn(o, r, n.d);
        for(var u = n.e, s = 0; u.length > s; s++)On(o, Hn(1 === e ? u[s] : u[s].b, r));
        return o;
    }
    function Pn(n, r, e) {
        for(var t in e){
            var a = e[t];
            "a1" === t ? Ln(n, a) : "a0" === t ? Mn(n, r, a) : "a3" === t ? Fn(n, a) : "a4" === t ? Yn(n, a) : ("value" !== t && "checked" !== t || n[t] !== a) && (n[t] = a);
        }
    }
    function Ln(n, r) {
        var e = n.style;
        for(var t in r)e[t] = r[t];
    }
    function Fn(n, r) {
        for(var e in r){
            var t = r[e];
            void 0 !== t ? n.setAttribute(e, t) : n.removeAttribute(e);
        }
    }
    function Yn(n, r) {
        for(var e in r){
            var t = r[e], a = t.f, i = t.o;
            void 0 !== i ? n.setAttributeNS(a, e, i) : n.removeAttributeNS(a, e);
        }
    }
    function Mn(n, r, e) {
        var t = n.elmFs || (n.elmFs = {});
        for(var a in e){
            var i = e[a], o = t[a];
            if (i) {
                if (o) {
                    if (o.q.$ === i.$) {
                        o.q = i;
                        continue;
                    }
                    n.removeEventListener(a, o);
                }
                o = Rn(r, i), n.addEventListener(a, o, xn && {
                    passive: 2 > we(i)
                }), t[a] = o;
            } else n.removeEventListener(a, o), t[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                xn = !0;
            }
        }));
    } catch (n) {}
    function Rn(n, r) {
        function e(r) {
            var t = e.q, a = W(t.a, r);
            if (me(a)) {
                for(var i, o = we(t), u = a.a, s = o ? 3 > o ? u.a : u.o : u, c = 1 == o ? u.b : 3 == o && u.O, f = (c && r.stopPropagation(), (2 == o ? u.b : 3 == o && u.L) && r.preventDefault(), n); i = f.j;){
                    if ("function" == typeof i) s = i(s);
                    else for(var l = i.length; l--;)s = i[l](s);
                    f = f.p;
                }
                f(s, c);
            }
        }
        return e.q = r, e;
    }
    function Vn(n, r) {
        return n.$ == r.$ && J(n.a, r.a);
    }
    function Wn(n, r, e, t) {
        var a = {
            $: r,
            r: e,
            s: t,
            t: void 0,
            u: void 0
        };
        return n.push(a), a;
    }
    function Bn(n, r, e, t) {
        if (n !== r) {
            var a = n.$, i = r.$;
            if (a !== i) {
                if (1 !== a || 2 !== i) return void Wn(e, 0, t, r);
                r = function(n) {
                    for(var r = n.e, e = r.length, t = Array(e), a = 0; e > a; a++)t[a] = r[a].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: t,
                        f: n.f,
                        b: n.b
                    };
                }(r), i = 1;
            }
            switch(i){
                case 5:
                    for(var o = n.l, u = r.l, s = o.length, c = s === u.length; c && s--;)c = o[s] === u[s];
                    if (c) return void (r.k = n.k);
                    r.k = r.m();
                    var f = [];
                    return Bn(n.k, r.k, f, 0), void (f.length > 0 && Wn(e, 1, t, f));
                case 4:
                    for(var l = n.j, d = r.j, v = !1, b = n.k; 4 === b.$;)v = !0, "object" != typeof l ? l = [
                        l,
                        b.j
                    ] : l.push(b.j), b = b.k;
                    for(var h = r.k; 4 === h.$;)v = !0, "object" != typeof d ? d = [
                        d,
                        h.j
                    ] : d.push(h.j), h = h.k;
                    return v && l.length !== d.length ? void Wn(e, 0, t, r) : ((v ? function(n, r) {
                        for(var e = 0; n.length > e; e++)if (n[e] !== r[e]) return !1;
                        return !0;
                    }(l, d) : l === d) || Wn(e, 2, t, d), void Bn(b, h, e, t + 1));
                case 0:
                    return void (n.a !== r.a && Wn(e, 3, t, r.a));
                case 1:
                    return void Dn(n, r, e, t, Un);
                case 2:
                    return void Dn(n, r, e, t, Jn);
                case 3:
                    if (n.h !== r.h) return void Wn(e, 0, t, r);
                    var p = Gn(n.d, r.d);
                    p && Wn(e, 4, t, p);
                    var m = r.i(n.g, r.g);
                    return void (m && Wn(e, 5, t, m));
            }
        }
    }
    function Dn(n, r, e, t, a) {
        if (n.c === r.c && n.f === r.f) {
            var i = Gn(n.d, r.d);
            i && Wn(e, 4, t, i), a(n, r, e, t);
        } else Wn(e, 0, t, r);
    }
    function Gn(n, r, e) {
        var t;
        for(var a in n)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in r) {
                var i = n[a], o = r[a];
                i === o && "value" !== a && "checked" !== a || "a0" === e && Vn(i, o) || ((t = t || {})[a] = o);
            } else (t = t || {})[a] = e ? "a1" === e ? "" : "a0" === e || "a3" === e ? void 0 : {
                f: n[a].f,
                o: void 0
            } : "string" == typeof n[a] ? "" : null;
        } else {
            var u = Gn(n[a], r[a] || {}, a);
            u && ((t = t || {})[a] = u);
        }
        for(var s in r)s in n || ((t = t || {})[s] = r[s]);
        return t;
    }
    function Un(n, r, e, t) {
        var a = n.e, i = r.e, o = a.length, u = i.length;
        o > u ? Wn(e, 6, t, {
            v: u,
            i: o - u
        }) : u > o && Wn(e, 7, t, {
            v: o,
            e: i
        });
        for(var s = u > o ? o : u, c = 0; s > c; c++){
            var f = a[c];
            Bn(f, i[c], e, ++t), t += f.b || 0;
        }
    }
    function Jn(n, r, e, t) {
        for(var a = [], i = {}, o = [], u = n.e, s = r.e, c = u.length, f = s.length, l = 0, d = 0, v = t; c > l && f > d;){
            var b = (O = u[l]).a, h = (T = s[d]).a, p = O.b, m = T.b, g = void 0, y = void 0;
            if (b !== h) {
                var $ = u[l + 1], w = s[d + 1];
                if ($) {
                    var k = $.a, A = $.b;
                    y = h === k;
                }
                if (w) {
                    var I = w.a, j = w.b;
                    g = b === I;
                }
                if (g && y) Bn(p, j, a, ++v), Kn(i, a, b, m, d, o), v += p.b || 0, Xn(i, a, b, A, ++v), v += A.b || 0, l += 2, d += 2;
                else if (g) v++, Kn(i, a, h, m, d, o), Bn(p, j, a, v), v += p.b || 0, l += 1, d += 2;
                else if (y) Xn(i, a, b, p, ++v), v += p.b || 0, Bn(A, m, a, ++v), v += A.b || 0, l += 2, d += 1;
                else {
                    if (!$ || k !== I) break;
                    Xn(i, a, b, p, ++v), Kn(i, a, h, m, d, o), v += p.b || 0, Bn(A, j, a, ++v), v += A.b || 0, l += 2, d += 2;
                }
            } else Bn(p, m, a, ++v), v += p.b || 0, l++, d++;
        }
        for(; c > l;){
            var O;
            v++, Xn(i, a, (O = u[l]).a, p = O.b, v), v += p.b || 0, l++;
        }
        for(; f > d;){
            var T, S = S || [];
            Kn(i, a, (T = s[d]).a, T.b, void 0, S), d++;
        }
        (a.length > 0 || o.length > 0 || S) && Wn(e, 8, t, {
            w: a,
            x: o,
            y: S
        });
    }
    var zn = "_elmW6BL";
    function Kn(n, r, e, t, a, i) {
        var o = n[e];
        if (!o) return i.push({
            r: a,
            A: o = {
                c: 0,
                z: t,
                r: a,
                s: void 0
            }
        }), void (n[e] = o);
        if (1 === o.c) {
            i.push({
                r: a,
                A: o
            }), o.c = 2;
            var u = [];
            return Bn(o.z, t, u, o.r), o.r = a, void (o.s.s = {
                w: u,
                A: o
            });
        }
        Kn(n, r, e + zn, t, a, i);
    }
    function Xn(n, r, e, t, a) {
        var i = n[e];
        if (i) {
            if (0 === i.c) {
                i.c = 2;
                var o = [];
                return Bn(t, i.z, o, a), void Wn(r, 9, a, {
                    w: o,
                    A: i
                });
            }
            Xn(n, r, e + zn, t, a);
        } else {
            var u = Wn(r, 9, a, void 0);
            n[e] = {
                c: 1,
                z: t,
                r: a,
                s: u
            };
        }
    }
    function Zn(n, r, e, t) {
        Qn(n, r, e, 0, 0, r.b, t);
    }
    function Qn(n, r, e, t, a, i, o) {
        for(var u = e[t], s = u.r; s === a;){
            var c = u.$;
            if (1 === c) Zn(n, r.k, u.s, o);
            else if (8 === c) u.t = n, u.u = o, (f = u.s.w).length > 0 && Qn(n, r, f, 0, a, i, o);
            else if (9 === c) {
                u.t = n, u.u = o;
                var f, l = u.s;
                l && (l.A.s = n, (f = l.w).length > 0 && Qn(n, r, f, 0, a, i, o));
            } else u.t = n, u.u = o;
            if (!(u = e[++t]) || (s = u.r) > i) return t;
        }
        var d = r.$;
        if (4 === d) {
            for(var v = r.k; 4 === v.$;)v = v.k;
            return Qn(n, v, e, t, a + 1, i, n.elm_event_node_ref);
        }
        for(var b = r.e, h = n.childNodes, p = 0; b.length > p; p++){
            a++;
            var m = 1 === d ? b[p] : b[p].b, g = a + (m.b || 0);
            if (!(a > s || s > g || (u = e[t = Qn(h[p], m, e, t, a, g, o)]) && (s = u.r) <= i)) return t;
            a = g;
        }
        return t;
    }
    function nr(n, r) {
        for(var e = 0; r.length > e; e++){
            var t = r[e], a = t.t, i = rr(a, t);
            a === n && (n = i);
        }
        return n;
    }
    function rr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, e) {
                    var t = n.parentNode, a = Hn(r, e);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = n.elm_event_node_ref), t && a !== n && t.replaceChild(a, n), a;
                }(n, r.s, r.u);
            case 4:
                return Pn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return nr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var e = r.s, t = 0; e.i > t; t++)n.removeChild(n.childNodes[e.v]);
                return n;
            case 7:
                for(var a = (e = r.s).e, i = n.childNodes[t = e.v]; a.length > t; t++)n.insertBefore(Hn(a[t], r.u), i);
                return n;
            case 9:
                if (!(e = r.s)) return n.parentNode.removeChild(n), n;
                var o = e.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = nr(n, e.w), n;
            case 8:
                return function(n, r) {
                    var e = r.s, t = function(n, r) {
                        if (n) {
                            for(var e = jn.createDocumentFragment(), t = 0; n.length > t; t++){
                                var a = n[t].A;
                                On(e, 2 === a.c ? a.s : Hn(a.z, r.u));
                            }
                            return e;
                        }
                    }(e.y, r);
                    n = nr(n, e.w);
                    for(var a = e.x, i = 0; a.length > i; i++){
                        var o = a[i], u = o.A, s = 2 === u.c ? u.s : Hn(u.z, r.u);
                        n.insertBefore(s, n.childNodes[o.r]);
                    }
                    return t && On(n, t), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                k(10);
        }
    }
    function er(n) {
        if (3 === n.nodeType) return Tn(n.textContent);
        if (1 !== n.nodeType) return Tn("");
        for(var r = c, e = n.attributes, t = e.length; t--;){
            var a = e[t];
            r = f(A2(_n, a.name, a.value), r);
        }
        var i = n.tagName.toLowerCase(), o = c, u = n.childNodes;
        for(t = u.length; t--;)o = f(er(u[t]), o);
        return A3(Sn, i, r, o);
    }
    var tr = F4(function(n, r, e, t) {
        return function(n, r, e, t, a, i) {
            var o = A2(V, n, r ? r.flags : void 0);
            me(o) || k(2);
            var u = {}, s = e(o.a), c = s.a, f = i(d, c), l = function(n, r) {
                var e;
                for(var t in dn){
                    var a = dn[t];
                    a.a && ((e = e || {})[t] = a.a(t, r)), n[t] = bn(a, r);
                }
                return e;
            }(u, d);
            function d(n, r) {
                var e = A2(t, n, c);
                f(c = e.a, r), kn(u, e.b, a(c));
            }
            return kn(u, s.b, a(c)), l ? {
                ports: l
            } : {};
        }(r, t, n.aE, n.a_, n.aW, function(r, e) {
            var t = n.M && n.M(r), a = n.a$, i = jn.title, o = jn.body, u = er(o);
            return function(n, r) {
                r(n);
                var e = 0;
                function t() {
                    e = 1 === e ? 0 : (ar(t), r(n), 1);
                }
                return function(a, i) {
                    n = a, i ? (r(n), 2 === e && (e = 1)) : (0 === e && ar(t), e = 2);
                };
            }(e, function(n) {
                yn = t;
                var e = a(n), s = Sn("body")(c)(e.av), f = function(n, r) {
                    var e = [];
                    return Bn(n, r, e, 0), e;
                }(u, s);
                o = function(n, r, e, t) {
                    return 0 === e.length ? n : (Zn(n, r, e, t), nr(n, e));
                }(o, u, f, r), u = s, yn = 0, i !== e.aZ && (jn.title = i = e.aZ);
            });
        });
    }), ar = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function ir() {
        return He(jn.location.href).a || k(1);
    }
    var or = ("undefined" != typeof document && document, "undefined" != typeof window ? window : {
        addEventListener: function() {},
        removeEventListener: function() {}
    }), ur = F3(function(n, r, e) {
        return nn(function(t) {
            function a(n) {
                t(r(e.I.a(n)));
            }
            var i = new XMLHttpRequest;
            i.addEventListener("error", function() {
                a(tt);
            }), i.addEventListener("timeout", function() {
                a(ot);
            }), i.addEventListener("load", function() {
                a(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? et : nt, function(n) {
                        return {
                            P: n.responseURL,
                            aT: n.status,
                            aU: n.statusText,
                            V: sr(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(e.I.b, i));
            }), ct(e.ak) && function(n, r, e) {
                r.upload.addEventListener("progress", function(t) {
                    r.c || tn(A2(ft, n, o(e, it({
                        aR: t.loaded,
                        ah: t.total
                    }))));
                }), r.addEventListener("progress", function(t) {
                    r.c || tn(A2(ft, n, o(e, at({
                        aP: t.loaded,
                        ah: t.lengthComputable ? xr(t.total) : qr
                    }))));
                });
            }(n, i, e.ak.a);
            try {
                i.open(e.aF, e.P, !0);
            } catch (n) {
                return a(rt(e.P));
            }
            return function(n, r) {
                for(var e = r.V; e.b; e = e.b)n.setRequestHeader(e.a.a, e.a.b);
                n.timeout = r.aY.a || 0, n.responseType = r.I.d, n.withCredentials = r.aq;
            }(i, e), e.av.a && i.setRequestHeader("Content-Type", e.av.a), i.send(e.av.b), function() {
                i.c = !0, i.abort();
            };
        });
    });
    function sr(n) {
        if (!n) return st;
        for(var r = st, e = n.split("\r\n"), t = e.length; t--;){
            var a = e[t], i = a.indexOf(": ");
            if (i > 0) {
                var o = a.substring(0, i), u = a.substring(i + 2);
                r = A3(It, o, function(n) {
                    return xr(ct(n) ? u + ", " + n.a : u);
                }, r);
            }
        }
        return r;
    }
    var cr = F3(function(n, r, e) {
        return {
            $: 0,
            d: n,
            b: r,
            a: e
        };
    }), fr = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(e) {
                return n(r.a(e));
            }
        };
    });
    function lr(n) {
        return new DataView(n);
    }
    var dr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), vr = F2(function(n) {
        return n;
    }), br = 1, hr = 2, pr = 0, mr = l, gr = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.d, a = n, i = A3(n, e.b, e.c, A3(gr, n, r, e.e));
            n = a, r = i, e = t;
        }
    }), yr = function(n) {
        return A3(gr, F3(function(n, r, e) {
            return A2(mr, o(n, r), e);
        }), c, n);
    }, $r = y, wr = F3(function(n, r, e) {
        var t = e.c, a = e.d, i = F2(function(r, e) {
            return A3($r, r.$ ? n : i, e, r.a);
        });
        return A3($r, i, A3($r, n, r, a), t);
    }), kr = function(n) {
        return A3(wr, mr, c, n);
    }, Ar = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ir = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), jr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Or = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Tr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Sr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qr = {
        $: 1
    }, Cr = x, _r = K, Nr = function(n) {
        return n + "";
    }, Er = F2(function(n, r) {
        return A2(T, n, function(n) {
            for(var r = []; n.b; n = n.b)r.push(n.a);
            return r;
        }(r));
    }), Hr = F2(function(n, r) {
        return d(A2(O, n, r));
    }), Pr = function(n) {
        return A2(Er, "\n    ", A2(Hr, "\n", n));
    }, Lr = F3(function(n, r, e) {
        for(;;){
            if (!e.b) return r;
            var t = e.b, a = n, i = A2(n, e.a, r);
            n = a, r = i, e = t;
        }
    }), Fr = function(n) {
        return A3(Lr, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Yr = v, Mr = F3(function(n, r, e) {
        for(;;){
            if (a(n, r) >= 1) return e;
            var t = n, i = r - 1, o = A2(mr, r, e);
            n = t, r = i, e = o;
        }
    }), Rr = F2(function(n, r) {
        return A3(Mr, n, r, c);
    }), Vr = F2(function(n, r) {
        return A3(Yr, n, A2(Rr, 0, Fr(r) - 1), r);
    }), Wr = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Br = function(n) {
        var r = Wr(n);
        return r >= 97 && 122 >= r;
    }, Dr = function(n) {
        var r = Wr(n);
        return 90 >= r && r >= 65;
    }, Gr = function(n) {
        return Br(n) || Dr(n) || function(n) {
            var r = Wr(n);
            return 57 >= r && r >= 48;
        }(n);
    }, Ur = function(n) {
        return A3(Lr, mr, c, n);
    }, Jr = F2(function(n, r) {
        return "\n\n(" + Nr(n + 1) + ") " + Pr(zr(r));
    }), zr = function(n) {
        return A2(Kr, n, c);
    }, Kr = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var e = n.a, t = n.b, a = function() {
                    var n, r, t = (r = (n = e).charCodeAt(0), isNaN(r) ? qr : xr(55296 > r || r > 56319 ? o(n[0], n.slice(1)) : o(n[0] + n[1], n.slice(2))));
                    if (1 === t.$) return !1;
                    var a, i = t.a, u = i.b;
                    return (Br(a = i.a) || Dr(a)) && A2(Cr, Gr, u);
                }();
                n = t, r = A2(mr, a ? "." + e : "['" + e + "']", r);
                continue n;
            case 1:
                t = n.b;
                var i = "[" + Nr(n.a) + "]";
                n = t, r = A2(mr, i, r);
                continue n;
            case 2:
                var u = n.a;
                if (u.b) {
                    if (u.b.b) {
                        var s = (r.b ? "The Json.Decode.oneOf at json" + A2(Er, "", Ur(r)) : "Json.Decode.oneOf") + " failed in the following " + Nr(Fr(u)) + " ways:";
                        return A2(Er, "\n\n", A2(mr, s, A2(Vr, Jr, u)));
                    }
                    n = t = u.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(Er, "", Ur(r)) : "!");
            default:
                var c = n.a, f = n.b;
                return (s = r.b ? "Problem with the value at json" + A2(Er, "", Ur(r)) + ":\n\n    " : "Problem with the given value:\n\n") + Pr(A2(_r, 4, f)) + "\n\n" + c;
        }
    }), Xr = 32, Zr = F4(function(n, r, e, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), Qr = [], ne = A, re = F2(function(n, r) {
        return j(r) / j(n);
    }), ee = ne(A2(re, 2, Xr)), te = A4(Zr, 0, ee, Qr, Qr), ae = b, ie = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oe = I, ue = function(n) {
        return n.length;
    }, se = F2(function(n, r) {
        return a(n, r) > 0 ? n : r;
    }), ce = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fe = h, le = F2(function(n, r) {
        for(;;){
            var e = A2(fe, Xr, n), t = e.b, a = A2(mr, ce(e.a), r);
            if (!t.b) return Ur(a);
            n = t, r = a;
        }
    }), de = function(n) {
        return n.a;
    }, ve = F2(function(n, r) {
        for(;;){
            var e = ne(r / Xr);
            if (1 === e) return A2(fe, Xr, n).a;
            n = A2(le, n, c), r = e;
        }
    }), be = F2(function(n, r) {
        if (r.a) {
            var e = r.a * Xr, t = oe(A2(re, Xr, e - 1)), a = n ? Ur(r.d) : r.d, i = A2(ve, a, r.a);
            return A4(Zr, ue(r.c) + e, A2(se, 5, t * ee), i, r.c);
        }
        return A4(Zr, ue(r.c), ee, Qr, r.c);
    }), he = F5(function(n, r, e, t, a) {
        for(;;){
            if (0 > r) return A2(be, !1, {
                d: t,
                a: e / Xr | 0,
                c: a
            });
            var i = ie(A3(ae, Xr, r, n));
            r -= Xr, t = A2(mr, i, t);
        }
    }), pe = F2(function(n, r) {
        if (n > 0) {
            var e = n % Xr;
            return A5(he, r, n - e - Xr, n, c, A3(ae, e, n - e, r));
        }
        return te;
    }), me = function(n) {
        return !n.$;
    }, ge = L, ye = F, $e = function(n) {
        return {
            $: 0,
            a: n
        };
    }, we = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, ke = function(n) {
        return n;
    }, Ae = F6(function(n, r, e, t, a, i) {
        return {
            aA: i,
            aC: r,
            H: t,
            aL: e,
            aM: n,
            aN: a
        };
    }), Ie = q, je = S, Oe = F2(function(n, r) {
        return 1 > n ? r : A3(je, n, r.length, r);
    }), Te = _, Se = function(n) {
        return "" === n;
    }, xe = F2(function(n, r) {
        return 1 > n ? "" : A3(je, 0, n, r);
    }), qe = F5(function(n, r, e, t, a) {
        if (Se(a) || A2(Ie, "@", a)) return qr;
        var i = A2(Te, ":", a);
        if (i.b) {
            if (i.b.b) return qr;
            var o = i.a, u = function(n) {
                for(var r = 0, e = n.charCodeAt(0), t = 43 == e || 45 == e ? 1 : 0, a = t; n.length > a; ++a){
                    var i = n.charCodeAt(a);
                    if (48 > i || i > 57) return qr;
                    r = 10 * r + i - 48;
                }
                return a == t ? qr : xr(45 == e ? -r : r);
            }(A2(Oe, o + 1, a));
            if (1 === u.$) return qr;
            var s = u;
            return xr(A6(Ae, n, A2(xe, o, a), s, r, e, t));
        }
        return xr(A6(Ae, n, a, qr, r, e, t));
    }), Ce = F4(function(n, r, e, t) {
        if (Se(t)) return qr;
        var a = A2(Te, "/", t);
        if (a.b) {
            var i = a.a;
            return A5(qe, n, A2(Oe, i, t), r, e, A2(xe, i, t));
        }
        return A5(qe, n, "/", r, e, t);
    }), _e = F3(function(n, r, e) {
        if (Se(e)) return qr;
        var t = A2(Te, "?", e);
        if (t.b) {
            var a = t.a;
            return A4(Ce, n, xr(A2(Oe, a + 1, e)), r, A2(xe, a, e));
        }
        return A4(Ce, n, qr, r, e);
    }), Ne = F2(function(n, r) {
        if (Se(r)) return qr;
        var e = A2(Te, "#", r);
        if (e.b) {
            var t = e.a;
            return A3(_e, n, xr(A2(Oe, t + 1, r)), A2(xe, t, r));
        }
        return A3(_e, n, qr, r);
    }), Ee = C, He = function(n) {
        return A2(Ee, "http://", n) ? A2(Ne, 0, A2(Oe, 7, n)) : A2(Ee, "https://", n) ? A2(Ne, 1, A2(Oe, 8, n)) : qr;
    }, Pe = function() {
        for(;;);
    }, Le = Q, Fe = Le(0), Ye = F4(function(n, r, e, t) {
        if (t.b) {
            var a = t.a, i = t.b;
            if (i.b) {
                var o = i.a, u = i.b;
                if (u.b) {
                    var s = u.a, c = u.b;
                    if (c.b) {
                        var f = c.b;
                        return A2(n, a, A2(n, o, A2(n, s, A2(n, c.a, e > 500 ? A3(Lr, n, r, Ur(f)) : A4(Ye, n, r, e + 1, f)))));
                    }
                    return A2(n, a, A2(n, o, A2(n, s, r)));
                }
                return A2(n, a, A2(n, o, r));
            }
            return A2(n, a, r);
        }
        return r;
    }), Me = F3(function(n, r, e) {
        return A4(Ye, n, r, 0, e);
    }), Re = F2(function(n, r) {
        return A3(Me, F2(function(r, e) {
            return A2(mr, n(r), e);
        }), c, r);
    }), Ve = rn, We = F2(function(n, r) {
        return A2(Ve, function(r) {
            return Le(n(r));
        }, r);
    }), Be = F3(function(n, r, e) {
        return A2(Ve, function(r) {
            return A2(Ve, function(e) {
                return Le(A2(n, r, e));
            }, e);
        }, r);
    }), De = function(n) {
        return A3(Me, Be(mr), Le(c), n);
    }, Ge = hn, Ue = F2(function(n, r) {
        var e = r;
        return an(A2(Ve, Ge(n), e));
    });
    dn.Task = vn(Fe, F3(function(n, r) {
        return A2(We, function() {
            return 0;
        }, De(A2(Re, Ue(n), r)));
    }), F3(function() {
        return Le(0);
    }), F2(function(n, r) {
        return A2(We, n, r);
    }));
    var Je = mn("Task"), ze = F2(function(n, r) {
        return Je(A2(We, n, r));
    }), Ke = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xe = {
        $: 4
    }, Ze = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Qe = {
        aA: qr,
        aC: "api.nebula.synthesis.rocks",
        H: "",
        aL: qr,
        aM: 1,
        aN: qr
    }, nt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), rt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, et = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), tt = {
        $: 2
    }, at = function(n) {
        return {
            $: 1,
            a: n
        };
    }, it = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ot = {
        $: 1
    }, ut = {
        $: -2
    }, st = ut, ct = function(n) {
        return !n.$;
    }, ft = pn, lt = i, dt = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return qr;
            var e = r.c, t = r.d, a = r.e;
            switch(A2(lt, n, r.b)){
                case 0:
                    r = t;
                    continue n;
                case 1:
                    return xr(e);
                default:
                    r = a;
                    continue n;
            }
        }
    }), vt = F5(function(n, r, e, t, a) {
        return {
            $: -1,
            a: n,
            b: r,
            c: e,
            d: t,
            e: a
        };
    }), bt = F5(function(n, r, e, t, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== t.$ || t.a || -1 !== t.d.$ || t.d.a) return A5(vt, n, r, e, t, a);
            var i = t.d;
            return o = t.e, A5(vt, 0, t.b, t.c, A5(vt, 1, i.b, i.c, i.d, i.e), A5(vt, 1, r, e, o, a));
        }
        var o, u = a.b, s = a.c, c = a.d, f = a.e;
        return -1 !== t.$ || t.a ? A5(vt, n, u, s, A5(vt, 0, r, e, t, c), f) : A5(vt, 0, r, e, A5(vt, 1, t.b, t.c, t.d, o = t.e), A5(vt, 1, u, s, c, f));
    }), ht = F3(function(n, r, e) {
        if (-2 === e.$) return A5(vt, 0, n, r, ut, ut);
        var t = e.a, a = e.b, i = e.c, o = e.d, u = e.e;
        switch(A2(lt, n, a)){
            case 0:
                return A5(bt, t, a, i, A3(ht, n, r, o), u);
            case 1:
                return A5(vt, t, a, r, o, u);
            default:
                return A5(bt, t, a, i, o, A3(ht, n, r, u));
        }
    }), pt = F3(function(n, r, e) {
        var t = A3(ht, n, r, e);
        return -1 !== t.$ || t.a ? t : A5(vt, 1, t.b, t.c, t.d, t.e);
    }), mt = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, e = n.e;
                return o = e.b, u = e.c, t = e.d, f = e.e, A5(vt, 1, n.b, n.c, A5(vt, 0, r.b, r.c, r.d, r.e), A5(vt, 0, o, u, t, f));
            }
            var t, a = n.d, i = n.e, o = i.b, u = i.c, s = (t = i.d).d, c = t.e, f = i.e;
            return A5(vt, 0, t.b, t.c, A5(vt, 1, n.b, n.c, A5(vt, 0, a.b, a.c, a.d, a.e), s), A5(vt, 1, o, u, c, f));
        }
        return n;
    }, gt = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, e = n.e;
                return c = e.b, f = e.c, l = e.d, d = e.e, A5(vt, 1, t = n.b, a = n.c, A5(vt, 0, r.b, r.c, r.d, u = r.e), A5(vt, 0, c, f, l, d));
            }
            var t = n.b, a = n.c, i = n.d, o = i.d, u = i.e, s = n.e, c = s.b, f = s.c, l = s.d, d = s.e;
            return A5(vt, 0, i.b, i.c, A5(vt, 1, o.b, o.c, o.d, o.e), A5(vt, 1, t, a, u, A5(vt, 0, c, f, l, d)));
        }
        return n;
    }, yt = F7(function(n, r, e, t, a, i, o) {
        if (-1 !== i.$ || i.a) {
            n: for(;;){
                if (-1 === o.$ && 1 === o.a) {
                    if (-1 === o.d.$) {
                        if (1 === o.d.a) return gt(r);
                        break n;
                    }
                    return gt(r);
                }
                break n;
            }
            return r;
        }
        return A5(vt, e, i.b, i.c, i.d, A5(vt, 0, t, a, i.e, o));
    }), $t = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, e = n.b, t = n.c, a = n.d, i = a.d, o = n.e;
            if (1 === a.a) {
                if (-1 !== i.$ || i.a) {
                    var u = mt(n);
                    if (-1 === u.$) {
                        var s = u.e;
                        return A5(bt, u.a, u.b, u.c, $t(u.d), s);
                    }
                    return ut;
                }
                return A5(vt, r, e, t, $t(a), o);
            }
            return A5(vt, r, e, t, $t(a), o);
        }
        return ut;
    }, wt = F2(function(n, r) {
        if (-2 === r.$) return ut;
        var e = r.a, t = r.b, i = r.c, o = r.d, u = r.e;
        if (0 > a(n, t)) {
            if (-1 === o.$ && 1 === o.a) {
                var s = o.d;
                if (-1 !== s.$ || s.a) {
                    var c = mt(r);
                    if (-1 === c.$) {
                        var f = c.e;
                        return A5(bt, c.a, c.b, c.c, A2(wt, n, c.d), f);
                    }
                    return ut;
                }
                return A5(vt, e, t, i, A2(wt, n, o), u);
            }
            return A5(vt, e, t, i, A2(wt, n, o), u);
        }
        return A2(kt, n, A7(yt, n, r, e, t, i, o, u));
    }), kt = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, a = r.b, i = r.c, o = r.d, u = r.e;
            if (e(n, a)) {
                var s = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(u);
                return -1 === s.$ ? A5(bt, t, s.b, s.c, o, $t(u)) : ut;
            }
            return A5(bt, t, a, i, o, A2(wt, n, u));
        }
        return ut;
    }), At = F2(function(n, r) {
        var e = A2(wt, n, r);
        return -1 !== e.$ || e.a ? e : A5(vt, 1, e.b, e.c, e.d, e.e);
    }), It = F3(function(n, r, e) {
        var t = r(A2(dt, n, e));
        return t.$ ? A2(At, n, e) : A3(pt, n, t.a, e);
    }), jt = F3(function(n, r, e) {
        return r(n(e));
    }), Ot = F2(function(n, r) {
        return A3(cr, "", ke, A2(jt, r, n));
    }), Tt = function(n) {
        return {
            $: 4,
            a: n
        };
    }, St = {
        $: 2
    }, xt = {
        $: 1
    }, qt = F2(function(n, r) {
        return r.$ ? Ar(n(r.a)) : Tr(r.a);
    }), Ct = F2(function(n, r) {
        switch(r.$){
            case 0:
                return Ar({
                    $: 0,
                    a: r.a
                });
            case 1:
                return Ar(xt);
            case 2:
                return Ar(St);
            case 3:
                return Ar({
                    $: 3,
                    a: r.a.aT
                });
            default:
                return A2(qt, Tt, n(r.b));
        }
    }), _t = {
        $: 0
    }, Nt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Et = F2(function(n, r) {
        return {
            ad: n,
            ai: r
        };
    }), Ht = Le(A2(Et, st, c)), Pt = function(n) {
        return nn(function(r) {
            var e = n.f;
            2 === e.$ && e.c && e.c(), n.f = null, r(Q(0));
        });
    }, Lt = an, Ft = F3(function(n, r, e) {
        n: for(;;){
            if (r.b) {
                var t = r.a, a = r.b;
                if (t.$) {
                    var i = t.a;
                    return A2(Ve, function(r) {
                        var t = i.ak;
                        return A3(Ft, n, a, 1 === t.$ ? e : A3(pt, t.a, r, e));
                    }, Lt(A3(ur, n, Ge(n), i)));
                }
                var o = t.a, u = A2(dt, o, e);
                if (1 === u.$) {
                    r = a;
                    continue n;
                }
                return A2(Ve, function() {
                    return A3(Ft, n, a, A2(At, o, e));
                }, Pt(u.a));
            }
            return Le(e);
        }
    }), Yt = F4(function(n, r, e, t) {
        return A2(Ve, function(n) {
            return Le(A2(Et, n, e));
        }, A3(Ft, n, r, t.ad));
    }), Mt = F3(function(n, r, e) {
        var t = n(r);
        return t.$ ? e : A2(mr, t.a, e);
    }), Rt = F2(function(n, r) {
        return A3(Me, Mt(n), c, r);
    }), Vt = F4(function(n, r, t, a) {
        var i = a.b;
        return e(r, a.a) ? xr(A2(Ge, n, i(t))) : qr;
    }), Wt = F3(function(n, r, e) {
        return A2(Ve, function() {
            return Le(e);
        }, De(A2(Rt, A3(Vt, n, r.a, r.b), e.ai)));
    }), Bt = F2(function(n, r) {
        if (r.$) {
            var e = r.a;
            return Nt({
                aq: e.aq,
                av: e.av,
                I: A2(fr, n, e.I),
                V: e.V,
                aF: e.aF,
                aY: e.aY,
                ak: e.ak,
                P: e.P
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), Dt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    dn.Http = vn(Ht, Yt, Wt, Bt, F2(function(n, r) {
        return A2(Dt, r.a, A2(jt, r.b, n));
    }));
    var Gt, Ut, Jt, zt, Kt, Xt, Zt = mn("Http"), Qt = (mn("Http"), function(n) {
        return Zt(Nt({
            aq: !1,
            av: n.av,
            I: n.I,
            V: n.V,
            aF: n.aF,
            aY: n.aY,
            ak: n.ak,
            P: n.P
        }));
    }), na = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + Nr(n.a);
    }), ra = F3(function(n, r, e) {
        return 1 === r.$ ? e : s(e, s(n, r.a));
    }), ea = function(n) {
        return A3(ra, "#", n.aA, A3(ra, "?", n.aN, s(A2(na, n.aL, s(n.aM ? "https://" : "http://", n.aC)), n.H)));
    }, ta = F2(function(n, r) {
        var e, t;
        return e = {
            I: (t = Ze, A2(Ot, t, Ct(Tr))),
            P: ea(u(Qe, {
                H: "/fetch/" + n + "/" + r
            }))
        }, Qt({
            av: _t,
            I: e.I,
            V: c,
            aF: "GET",
            aY: qr,
            ak: qr,
            P: e.P
        });
    }), aa = $, ia = F2(function(n, r) {
        var e = r.d, t = function(r) {
            return r.$ ? ie(A2(aa, n, r.a)) : ce(A2(aa, t, r.a));
        };
        return A4(Zr, r.a, r.b, A2(aa, t, r.c), A2(aa, n, e));
    }), oa = gn(c), ua = F3(function(n, r, e) {
        for(;;){
            var t = A2(fe, Xr, n), i = t.a, o = t.b;
            if (0 > a(ue(i), Xr)) return A2(be, !0, {
                d: r,
                a: e,
                c: i
            });
            n = o, r = A2(mr, ie(i), r), e += 1;
        }
    }), sa = function(n) {
        return n.b ? A3(ua, n, c, 0) : te;
    }, ca = sa(d([
        {
            as: sa(d([
                "Well defined task",
                "Multi-step tasks with clear instructions",
                "Complex tasks with clearly defined objectives and constraints",
                "Singular objective with easily identifiable tasks",
                "Tasks with interdependent steps and ambiguous constraints",
                "Complex problems with multiple possible solutions",
                "Ill-defined problem"
            ])),
            v: "This dimension measures the problem a business addresses or a a person solves for. It is described in terms of the complexity (task, objective, or problem) and how well it is understood (well defined through to ill defined).",
            w: sa(d([
                "Well defined task a simple action with well defined inputs and outputs",
                "Multi-step tasks with clear instructions a sequence of actions that are equally well defined",
                "Complex tasks with clearly defined objectives and constraints a complex set of actions working towards an objective with well defined constraints",
                "Singular objective with easily identifiable tasks only the objective is stated and the tasks need to be first identified",
                "Tasks with interdependent steps and ambiguous constraints complex string of tasks that may be constrained in non-obvious ways",
                "Complex problems with multiple possible solutions a complicated problem, potentially only described through symptoms where multiple solutions may exist that need to be critically evaluated",
                "Ill-defined problem a broadly described problem with nothing else immediately obvious"
            ])),
            aO: "Problem dimension",
            aS: "How well known is the problem?"
        },
        {
            as: sa(d([
                "Simple automation interface available",
                "API integration and interaction",
                "Web-based graphical user interface (GUI)",
                "Proprietary interfaces or simple physical manipulations",
                "Spanning combinations of interfaces",
                "Voice recognition and interaction interface",
                "Varied and dynamic, or complex physical interface"
            ])),
            v: "The interface dimension is a measure of how the solution interacts with the problem space. For example a it could be a simple interface through which comments are recorded, or a complex physical problem (like threading the needle).",
            w: sa(d([
                "Simple automation interface available a simple field that requires no interaction save for the task of input",
                "API integration and interaction an addressable interface that has a well understood set of inputs",
                "Web-based graphical user interface (GUI) a flexible interface designed around a user experience",
                "Proprietary interfaces or simple physical manipulations an uncommon interface for some well defined system or physical problem that can easily manipulated with actuators",
                "Spanning combinations of interfaces a collection of digital interfaces or physical problems",
                "Voice recognition and interaction interface a system that can be interacted through voice or interactive interfaces",
                "Varied and dynamic, or complex physical interface an ill defined way of interacting with systems or freeform and abstract ways of manipulating systems"
            ])),
            aO: "Interface dimension",
            aS: "How do you interact with the problem space?"
        },
        {
            as: sa(d([
                "Depends on simple human manipulation",
                "Basic digital tools and software suites",
                "Use of cloud-based platforms for collaboration and productivity",
                "Spans multiple systems that have different modes of interaction",
                "Adoption of AI-assisted tools for process optimization",
                "Integrated smart systems across multiple domains (IoT, predictive analytics)",
                "Abstract, used to create systems"
            ])),
            v: "The technology dimension speaks to the technology that lies under the problem interface. At the most basic, there is no underlying technology and it is just a recordal of the input. At the most complex the technology itself creates systems that others may use.",
            w: sa(d([
                "Depends on simple human manipulation easily changed or controlled by a human",
                "Basic digital tools and software suites knowledge of a tool or tool chain enables solution",
                "Use of cloud-based platforms for collaboration and productivity technology spans latest innovations allowing for multiple parallel threads to interact simultaneously",
                "Spans multiple systems that have different modes of interaction technology consists of many distinct parts that have different interfaces",
                "Adoption of AI-assisted tools for process optimization technology begins to optimise the tasks within itself",
                "Integrated smart systems across multiple domains (IoT, predictive analytics) self optimising technology spans multiple domains",
                "Abstract, used to create systems the technology is abstracted and is used to create new systems"
            ])),
            aO: "Technology dimension",
            aS: "How mature is the available technology?"
        },
        {
            as: sa(d([
                "Humans as process drivers",
                "Humans as process supervisors",
                "Humans as quality controllers",
                "Humans as process optimisers",
                "Humans as system analysts",
                "Humans as system tacticians",
                "Humans as system strategists and creators"
            ])),
            v: "Operational dimensions measure the specific role a human undertakes: folks can be the process drivers where their inputs are used verbatim, through to supervisory and control; at a bit more maturity they can get optimised, through to creators.",
            w: sa(d([
                "Process drivers inputs step the process forward",
                "Process supervisors process is monitored through outputs",
                "Quality controllers process parameters are controlled through inputs",
                "Process optimisers processes are changed to become more optimised",
                "System analysts systems are analysed for find new ways of solving the problem",
                "System tacticians new tactics are innovated to improve the system",
                "System strategists and creators systems are created to address broad problems with potentially new strategies all together, ability to pivot"
            ])),
            aO: "Operations dimension",
            aS: "What role do people currently play?"
        },
        {
            as: sa(d([
                "Operators, interface specific experts",
                "Task experts with tool understanding",
                "Data interpreters with analytical skills",
                "Function generators",
                "AI-assisted decision-makers",
                "System architects",
                "Innovators, abstract thinkers"
            ])),
            v: "The people dimension is different to the operational dimension in that it speaks to the sophistication of the system input generator. So an operator is someone who is following a set of tasks with minimal input modulation; whereas innovators, and abstract thinkers are folks who are not thinking along any predefined process.",
            w: sa(d([
                "Operators, interface specific experts people are trained in the specific nuances of a specific tool or tool chain",
                "Task experts with tool understanding a tool may be manipulated to facilitate a specific solution that has not been solved directly before",
                "Data interpreters with analytical skills output is thought about critically with new insights generated from numerical trends",
                "Function generators new functions are created to make solutions easier to solve",
                "AI-assisted decision-makers some degree of decisioning is handed off to AI systems",
                "System architects complex solution architecture is created to solve problems",
                "Innovators, abstract thinkers problems are looked at in unique ways and folks can apply thinking specific in one domain in abstract ways"
            ])),
            aO: "People dimension",
            aS: "How sophisticated is the thinking of team members?"
        },
        {
            as: sa(d([
                "Commoditised, regional player",
                "Niche specialist within regional markets",
                "National recognition with standard offerings",
                "Well established sector, significant differentiators",
                "Global player with unique product/service offerings",
                "Industry disruptor with groundbreaking technology",
                "One-of-a-kind"
            ])),
            v: "The specific business undertaken in the context of the market. If there are many similar players with little differentiation then there are multiple interested parties looking for advantages from disruption. If there is only one player, then the source of disruption is internal and appetite for– is likely low.",
            w: sa(d([
                "Commoditised, regional player lots of very similar businesses",
                "Niche specialist within regional markets a business that has a differentiated value offering in a regional niche",
                "National recognition with standard offerings a business that is unique at a national level with limited access to international markets",
                "Well established sector, significant differentiators significantly different business within a well known sector",
                "Global player with unique product/service offerings a global firm that has differentiated offerings",
                "Industry disruptor with groundbreaking technology a firm that brings many new ways of doing business",
                "One-of-a-kind an innovative first mover"
            ])),
            aO: "Business dimension",
            aS: "How unique is your business?"
        }
    ])), fa = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), la = {
        $: 0
    }, da = F5(function(n, r, e, t, a) {
        return {
            r: t,
            s: e,
            q: r,
            m: a,
            u: n
        };
    }), va = F2(function(n, r) {
        return A5(da, r.u, r.q, r.s, r.r, n(r.m));
    }), ba = F2(function(n, r) {
        var e = r;
        return function(r) {
            var t = r.u, a = r.q, i = r.s, o = r.r;
            return A2(Re, va(r.m), e(A5(da, t, a, i, o, n)));
        };
    }), ha = F2(function(n, r) {
        return r.b ? A3(Me, mr, r, n) : n;
    }), pa = F2(function(n, r) {
        return A3(Me, ha, c, A2(Re, n, r));
    }), ma = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(mr, n.a, ma(n.b)) : c;
    }, ga = F2(function(n, r) {
        return xr(1 === r.$ ? d([
            n
        ]) : A2(mr, n, r.a));
    }), ya = function(n) {
        try {
            return xr(decodeURIComponent(n));
        } catch (n) {
            return qr;
        }
    }, $a = F2(function(n, r) {
        var e = A2(Hr, "=", n);
        if (e.b && e.b.b && !e.b.b.b) {
            var t = e.b.a, a = ya(e.a);
            if (1 === a.$) return r;
            var i = a.a, o = ya(t);
            return 1 === o.$ ? r : A3(It, i, ga(o.a), r);
        }
        return r;
    }), wa = F2(function(n, r) {
        var e;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, e = r.q;
                    if (e.b) {
                        if ("" !== e.a || e.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return xr(r.m);
                    }
                    return xr(r.m);
                }
                return qr;
            }
        }(n(A5(da, c, function(n) {
            var r = A2(Hr, "/", n);
            return ma(r.b && "" === r.a ? r.b : r);
        }(r.H), 1 === (e = r.aN).$ ? st : A3(Me, $a, st, A2(Hr, "&", e.a)), r.aA, ke)));
    }), ka = F2(function(n, r) {
        var e = n, t = r;
        return function(n) {
            return A2(pa, t, e(n));
        };
    }), Aa = F2(function(n, r) {
        return function(n) {
            var e = n.u, t = n.q, a = n.s, i = n.r, o = n.m;
            if (t.b) {
                var u = t.a, s = t.b, f = r(u);
                if (f.$) return c;
                var l = f.a;
                return d([
                    A5(da, A2(mr, u, e), s, a, i, o(l))
                ]);
            }
            return c;
        };
    }), Ia = A2(Aa, "STRING", xr), ja = function(n) {
        return d([
            n
        ]);
    }, Oa = F3(function(n, r) {
        var t = function(n) {
            var r, t = (r = d([
                A2(ba, la, ja),
                A2(ba, fa, A2(ka, function(n) {
                    var r = n.u, t = n.q, a = n.s, i = n.r, o = n.m;
                    if (t.b) {
                        var u = t.a, s = t.b;
                        return e(u, "fetch") ? d([
                            A5(da, A2(mr, u, r), s, a, i, o)
                        ]) : c;
                    }
                    return c;
                }, A2(ka, Ia, Ia)))
            ]), function(n) {
                return A2(pa, function(r) {
                    return r(n);
                }, r);
            });
            return A2(wa, t, n);
        }(r);
        if (t.$ || 1 !== t.a.$) return o(Ke(A2(ia, function(n) {
            return {
                ar: qr,
                aO: n
            };
        }, ca)), oa);
        var a = t.a;
        return o(Xe, A2(ta, a.a, a.b));
    }), Ta = gn(c), Sa = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), xa = {
        $: 3
    }, qa = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ca = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), _a = {
        $: 2
    }, Na = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ea = F2(function(n, r) {
        return {
            at: n,
            C: r
        };
    }), Ha = R, Pa = H, La = F5(function(n, r, e, t, a) {
        return {
            a1: n,
            a2: r,
            a3: e,
            a4: t,
            a5: a
        };
    }), Fa = F3(function(n, r, e) {
        return {
            aH: n,
            aV: r,
            aX: e
        };
    }), Ya = function(n) {
        return A3(Lr, F2(function(n, r) {
            return A3(pt, n.a, n.b, r);
        }), st, n);
    }, Ma = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Ra = E, Va = Ma(d([
        function(n) {
            return {
                $: 3,
                b: n
            };
        }(Ra),
        A2(ge, function(n) {
            return d([
                n
            ]);
        }, Ra),
        A2(ge, function(n) {
            var r;
            return r = n, A3(gr, F3(function(n, r, e) {
                return A2(mr, r, e);
            }), c, r);
        }, (Gt = Ra, A2(ge, Ya, function(n) {
            return {
                $: 8,
                b: n
            };
        }(Gt))))
    ])), Wa = A4(Y, Fa, Ma(d([
        A2(Pa, "objectives", Va),
        A2(Pa, "objective", Va)
    ])), A2(Pa, "steps", Va), A2(Pa, "success_criteria", Va)), Ba = A6(M, La, A2(Pa, "Year_1", Wa), A2(Pa, "Year_2", Wa), A2(Pa, "Year_3", Wa), A2(Pa, "Year_4", Wa), A2(Pa, "Year_5", Wa)), Da = function(n) {
        var r = A2(Ha, Ra, n);
        if (r.$) return Ar(Na(zr(r.a)));
        var e = r.a, t = A2(Ha, A3(ye, Ea, A2(Pa, "archetype_name", Ra), A2(Pa, "plan", Ba)), e);
        return t.$ ? Ar(Na(zr(t.a))) : Tr(t.a);
    }, Ga = function(n) {
        return A2(ze, Pe, nn(function() {
            try {
                or.location = n;
            } catch (n) {
                jn.location.reload(!1);
            }
        }));
    }, Ua = {
        $: 4
    }, Ja = F2(function(n, r) {
        return A3(cr, "arraybuffer", lr, A2(jt, r, n));
    }), za = function(n) {
        return A2(Ja, n, Ct(function() {
            return Tr(0);
        }));
    }, Ka = function(n) {
        return A2(dr, "application/json", A2(_r, 0, n));
    }, Xa = g, Za = F3(function(n, r, e) {
        var t = e.c, a = e.d, i = F2(function(r, e) {
            return A3(Xa, r.$ ? n : i, e, r.a);
        });
        return A3(Xa, n, A3(Xa, i, r, t), a);
    }), Qa = F2(function(n, r) {
        return A3(Za, function(n) {
            return F2(function(r, e) {
                return e.push(n(r)), e;
            });
        }(n), [], r);
    }), ni = 4294967295 >>> 32 - ee, ri = p, ei = F3(function(n, r, e) {
        for(;;){
            var t = A2(ri, ni & r >>> n, e);
            if (t.$) return A2(ri, ni & r, t.a);
            n -= ee, e = t.a;
        }
    }), ti = function(n) {
        return n >>> 5 << 5;
    }, ai = F2(function(n, r) {
        var e = r.a, t = r.b, i = r.c, o = r.d;
        return 0 > n || a(n, e) > -1 ? qr : a(n, ti(e)) > -1 ? xr(A2(ri, ni & n, o)) : xr(A3(ei, t, n, i));
    }), ii = function(n) {
        return A3(Lr, F2(function(n, r) {
            return A3(Z, n.a, n.b, r);
        }), {}, n);
    }, oi = X, ui = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), si = function(n) {
        var r;
        return ii(d([
            o("question", oi(n.aO.aS)),
            o("answer", oi((r = n.ar, 1 === r.$ ? "Unknown" : A2(ui, "Unknown", A2(ai, r.a, n.aO.as)))))
        ]));
    }, ci = F2(function(n, r) {
        return ii(d([
            o("email", oi(r)),
            o("answers", A2(Qa, si, n))
        ]));
    }), fi = function(n) {
        return Qt({
            av: n.av,
            I: n.I,
            V: c,
            aF: "POST",
            aY: qr,
            ak: qr,
            P: n.P
        });
    }, li = F2(function(n, r) {
        return fi({
            av: Ka(A2(ci, n, r)),
            I: za(vr(Ua)),
            P: ea(u(Qe, {
                H: "/submit/"
            }))
        });
    }), di = {
        $: 5
    }, vi = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.e, a = n, i = A3(n, e.b, e.c, A3(vi, n, r, e.d));
            n = a, r = i, e = t;
        }
    }), bi = F3(function(n, r, e) {
        return A3(vi, F3(function(e, t, a) {
            return A3(Z, n(e), r(t), a);
        }), {}, e);
    }), hi = X, pi = {
        $: 1
    }, mi = m, gi = F4(function(n, r, e, t) {
        var a = ni & r >>> n, i = A2(ri, a, t);
        return A3(mi, a, i.$ ? ie(A3(mi, ni & r, e, i.a)) : ce(A4(gi, n - ee, r, e, i.a)), t);
    }), yi = F3(function(n, r, e) {
        var t = e.a, i = e.b, o = e.c, u = e.d;
        return 0 > n || a(n, t) > -1 ? e : a(n, ti(t)) > -1 ? A4(Zr, t, i, o, A3(mi, ni & n, r, u)) : A4(Zr, t, i, A4(gi, i, n, r, o), u);
    }), $i = F3(function(n, r, e) {
        var t = A2(ai, r, n);
        return 1 === t.$ ? Ar(pi) : Tr(A3(yi, r, u(t.a, {
            ar: xr(e)
        }), n));
    }), wi = F2(function(n, r) {
        var e, t, a = o(n, r);
        n: for(;;)switch(a.a.$){
            case 9:
                return o(r, a.a.a.$ ? Ga(a.a.a.a) : oa);
            case 0:
                if (a.b.$) break n;
                var i = a.a, s = A3($i, a.b.a, i.a, i.b);
                if (1 === s.$) return o(qa(s.a), oa);
                var c = s.a;
                return o(Ke(c), (t = void 0, fi({
                    av: Ka((t = c, A3(bi, ke, ke, Ya(d([
                        o("selections", A2(Qa, function(n) {
                            var r = n.ar;
                            return 1 === r.$ ? null : hi(r.a);
                        }, t))
                    ]))))),
                    I: za(vr(di)),
                    P: ea(u(Qe, {
                        H: "/telemetry/"
                    }))
                })));
            case 1:
                if (1 === a.b.$) return o(A2(Sa, a.b.a, a.a.a), oa);
                break n;
            case 2:
                if (a.b.$) break n;
                return o(A2(Sa, a.b.a, ""), oa);
            case 5:
                return o(r, oa);
            case 3:
                if (1 === a.b.$) {
                    var f = a.b;
                    return o(_a, A2(li, f.a, f.b));
                }
                break n;
            case 4:
                return o(xa, oa);
            case 7:
                if (1 === a.a.a.$) {
                    if (4 === a.b.$) return o(qa({
                        $: 3,
                        a: (e = a.a.a.a, "Http error -> " + function() {
                            switch(e.$){
                                case 0:
                                    return "Bad Url: " + e.a;
                                case 1:
                                    return "Timeout";
                                case 2:
                                    return "Network error.";
                                case 3:
                                    return "Bad status: " + Nr(e.a);
                                default:
                                    return "Bad body: " + e.a;
                            }
                        }())
                    }), oa);
                    break n;
                }
                if (4 === a.b.$) {
                    var l = Da(a.a.a.a);
                    return o(1 === l.$ ? qa(l.a) : {
                        $: 6,
                        a: l.a
                    }, oa);
                }
                break n;
            default:
                break n;
        }
        return o(qa(A2(Ca, r, n)), oa);
    }), ki = Sn("div"), Ai = Sn("h1"), Ii = function(n) {
        switch(n.$){
            case 0:
                return "General Error.";
            case 1:
                return "Index out of bounds.";
            case 2:
                return "Invalid model-message.";
            case 3:
                return "Failed to load plan: " + n.a;
            default:
                return "Failed to decode response: " + n.a;
        }
    }, ji = Tn, Oi = c, Ti = Sn("a"), Si = F2(function(n, r) {
        return A2(Cn, n, oi(r));
    }), xi = Sn("p"), qi = d([
        A2(ki, c, d([
            A2(Ai, c, d([
                ji("Strategic plan")
            ])),
            A2(xi, c, d([
                ji("Almost there, but we can't find the plan you requested.")
            ])),
            A2(xi, c, d([
                ji("Its an easy fix, though! Head on over to nebula and complete the questionnaire.  We'll fire off an email to you as soon as we've built your plan!")
            ])),
            A2(xi, c, d([
                A2(Ti, d([
                    A2(Si, "href", /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i.test("https://nebula.synthesis.rocks") ? "" : "https://nebula.synthesis.rocks")
                ]), d([
                    ji("nebula.synthesis.rocks")
                ]))
            ]))
        ]))
    ]), Ci = Si("className"), _i = Sn("h2"), Ni = Sn("h3"), Ei = Sn("li"), Hi = Sn("ol"), Pi = Sn("ul"), Li = F2(function(n, r) {
        return A2(ki, d([
            Ci("yearplan")
        ]), d([
            A2(ki, c, c),
            A2(ki, c, c),
            A2(ki, c, d([
                A2(_i, c, d([
                    ji(n)
                ])),
                A2(Ni, c, d([
                    ji("Objectives")
                ])),
                A2(Pi, c, A2(Re, function(n) {
                    return A2(Ei, c, d([
                        ji(n)
                    ]));
                }, r.aH)),
                A2(Ni, c, d([
                    ji("Steps")
                ])),
                A2(Hi, c, A2(Re, function(n) {
                    return A2(Ei, c, d([
                        ji(n)
                    ]));
                }, r.aV)),
                A2(Ni, c, d([
                    ji("Success criteria")
                ])),
                A2(Pi, c, A2(Re, function(n) {
                    return A2(Ei, c, d([
                        ji(n)
                    ]));
                }, r.aX))
            ]))
        ]));
    }), Fi = {
        $: 3
    }, Yi = Sn("button"), Mi = Sn("input"), Ri = qn, Vi = F2(function(n, r) {
        return A2(Ri, n, {
            $: 0,
            a: r
        });
    }), Wi = function(n) {
        return A2(Vi, "click", $e(n));
    }, Bi = function(n) {
        return o(n, !0);
    }, Di = F2(function(n, r) {
        return A2(Ri, n, {
            $: 1,
            a: r
        });
    }), Gi = F2(function(n, r) {
        return A3(Me, Pa, r, n);
    }), Ui = A2(Gi, d([
        "target",
        "value"
    ]), Ra), Ji = Si("placeholder"), zi = Si("value"), Ki = d([
        A2(ki, d([
            Ci("submit")
        ]), d([
            A2(Ai, c, d([
                ji("Thank you")
            ])),
            A2(ki, c, d([
                A2(ki, c, d([
                    ji("Check your email for your five year strategic plan.")
                ]))
            ]))
        ]))
    ]), Xi = d([
        A2(ki, d([
            Ci("submit")
        ]), d([
            A2(Ai, c, d([
                ji("Processing submission")
            ])),
            A2(ki, c, d([
                A2(ki, c, d([
                    ji("Hold tight while we generate a business plan to leverage the disruptive power of generative AI for you...")
                ]))
            ]))
        ])),
        A2(ki, d([
            Ci("progress")
        ]), d([
            A2(ki, c, d([
                A2(ki, c, c)
            ]))
        ]))
    ]), Zi = {
        $: 2
    }, Qi = w, no = F2(function(n, r) {
        var e = r.c, t = r.d, a = {
            d: c,
            a: 0,
            c: A3(Qi, n, ti(r.a), t)
        }, i = F2(function(r, e) {
            if (r.$) {
                var t = ie(A3(Qi, n, e.a * Xr, r.a));
                return {
                    d: A2(mr, t, e.d),
                    a: e.a + 1,
                    c: e.c
                };
            }
            return A3(Xa, i, e, r.a);
        });
        return A2(be, !0, A3(Xa, i, a, e));
    }), ro = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), eo = F2(function(n, r) {
        return A3(Me, F2(function(r, e) {
            return n(r) ? A2(mr, r, e) : e;
        }), c, r);
    }), to = function(n) {
        return n.b;
    }, ao = function(n) {
        return Ci(A2(Er, " ", A2(Re, de, A2(eo, to, n))));
    }, io = F2(function(n, r) {
        return A2(ki, d([
            Ci("question")
        ]), d([
            A2(ki, c, d([
                A2(ki, d([
                    Ci("number")
                ]), d([
                    ji(Nr(r + 1))
                ])),
                A2(Ni, c, d([
                    ji(n.aO.aO)
                ]))
            ])),
            A2(_i, c, d([
                ji(n.aO.aS)
            ])),
            A2(ki, c, A2(Vr, F2(function(e, t) {
                return A2(Yi, d([
                    Wi(A2(ro, r, e)),
                    function() {
                        var t = n.ar;
                        if (t.$) return ao(c);
                        var i, u = t.a;
                        return ao(d([
                            o("button-selected", 1 > a(e, u)),
                            o((i = d([
                                "q",
                                Nr(r + 1)
                            ]), A2(Er, "", i)), 1 > a(e, u))
                        ]));
                    }()
                ]), d([
                    ji(t)
                ]));
            }), kr(n.aO.as))),
            A2(ki, d([
                Ci("path")
            ]), d([
                A2(ki, c, c)
            ]))
        ]));
    });
    Ut = {
        Main: {
            init: (Jt = {
                aE: Oa,
                aI: vr({
                    $: 10
                }),
                aJ: function(n) {
                    return {
                        $: 9,
                        a: n
                    };
                },
                aW: vr(Ta),
                a_: wi,
                a$: function(n) {
                    return {
                        av: function() {
                            switch(n.$){
                                case 4:
                                    return Oi;
                                case 0:
                                    return i = n.a, d([
                                        A2(ki, d([
                                            Ci("questions")
                                        ]), s(d([
                                            A2(Ai, c, d([
                                                ji("Strategy generator")
                                            ])),
                                            A2(ki, c, d([
                                                A2(xi, c, d([
                                                    ji("Understanding where the disruptive effects of generative AI will be felt in your business is no easy task.  We have built a framework that will assist you in identifying those areas that will feel the disruptive effects more keenly, as well as guiding you to leverage the disruption.   ")
                                                ]))
                                            ]))
                                        ]), s(kr(A2(no, F2(function(n, r) {
                                            return A2(io, r, n);
                                        }), i)), d([
                                            A2(ki, c, d([
                                                A2(Yi, d([
                                                    Wi(Zi),
                                                    Ci("submitbutton")
                                                ]), d([
                                                    ji("Get your archetype")
                                                ]))
                                            ]))
                                        ]))))
                                    ]);
                                case 1:
                                    return t = n.b, d([
                                        A2(ki, d([
                                            Ci("submit")
                                        ]), d([
                                            A2(Ai, c, d([
                                                ji("Get your plan")
                                            ])),
                                            A2(ki, c, d([
                                                A2(ki, c, d([
                                                    ji("Find out your archetype and get your five-year strategic plan.")
                                                ]))
                                            ])),
                                            A2(ki, c, d([
                                                A2(Mi, d([
                                                    (a = function(n) {
                                                        return {
                                                            $: 1,
                                                            a: n
                                                        };
                                                    }, A2(Di, "input", A2(ge, Bi, A2(ge, a, Ui)))),
                                                    zi(t),
                                                    Ji("Enter your email address")
                                                ]), d([
                                                    ji("email address")
                                                ]))
                                            ])),
                                            A2(ki, c, d([
                                                A2(ki, c, d([
                                                    A2(Yi, d([
                                                        Wi(Fi),
                                                        Ci("email")
                                                    ]), d([
                                                        ji("Get your plan")
                                                    ]))
                                                ]))
                                            ]))
                                        ]))
                                    ]);
                                case 2:
                                    return Xi;
                                case 3:
                                    return Ki;
                                case 5:
                                    return qi;
                                case 6:
                                    return e = n.a, d([
                                        A2(ki, c, d([
                                            A2(Ai, c, d([
                                                ji("Strategic plan")
                                            ])),
                                            A2(xi, c, d([
                                                ji("This strategic plan has been compiled based on your answers to the disruption self-assessment questionnaire.")
                                            ])),
                                            A2(xi, c, d([
                                                ji("Your archetype is: " + e.at)
                                            ])),
                                            A2(Li, "Year 1", e.C.a1),
                                            A2(Li, "Year 2", e.C.a2),
                                            A2(Li, "Year 3", e.C.a3),
                                            A2(Li, "Year 4", e.C.a4),
                                            A2(Li, "Year 5", e.C.a5),
                                            A2(xi, c, d([
                                                ji("This plan has the power to become the most exciting moment in the history of your business: we encourage you to take this plan and implement it for your benefit.  Big things can come from small beginnings, and we hope that this plan may become exactly that for you.")
                                            ]))
                                        ]))
                                    ]);
                                default:
                                    return r = n.a, d([
                                        A2(ki, c, d([
                                            A2(Ai, c, d([
                                                ji("Error")
                                            ])),
                                            A2(ki, c, d([
                                                ji(Ii(r))
                                            ])),
                                            A2(ki, c, d([
                                                ji("Errors do not make great strategies, so don't use this, but rather please try again and we hope it'll be better.")
                                            ]))
                                        ]))
                                    ]);
                            }
                            var r, e, t, a, i;
                        }(),
                        aZ: "Strategic plan: disruption leverage"
                    };
                }
            }, zt = Jt.aI, Kt = Jt.aJ, Xt = function() {
                Xt.a(zt(ir()));
            }, tr({
                M: function(n) {
                    return Xt.a = n, or.addEventListener("popstate", Xt), 0 > or.navigator.userAgent.indexOf("Trident") || or.addEventListener("hashchange", Xt), F2(function(r, e) {
                        if (!(e.ctrlKey || e.metaKey || e.shiftKey || e.button >= 1 || r.target || r.hasAttribute("download"))) {
                            e.preventDefault();
                            var t = r.href, a = ir(), i = He(t).a;
                            n(Kt(i && a.aM === i.aM && a.aC === i.aC && a.aL.a === i.aL.a ? {
                                $: 0,
                                a: i
                            } : function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(t)));
                        }
                    });
                },
                aE: function(n) {
                    return A3(Jt.aE, n, ir(), Xt);
                },
                a$: Jt.a$,
                a_: Jt.a_,
                aW: Jt.aW
            }))($e(0))(0)
        }
    }, n.Elm ? function n(r, e) {
        for(var t in e)t in r ? "init" == t ? k(6) : n(r[t], e[t]) : r[t] = e[t];
    }(n.Elm, Ut) : n.Elm = Ut;
}($a0b4f895e1596b3b$exports);


(0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("myapp")
});


//# sourceMappingURL=index.e2929681.js.map
